import {
  Avatar,
  Box,
  Typography,
  useTheme,
  Select,
  MenuItem,
} from "@mui/material";
import { tokens } from "../theme";
import React, { useEffect } from "react";
import Grid from "@mui/material/Unstable_Grid2"; // Grid version 2
import { useState } from "react";
import Pagination from "@mui/material/Pagination";
import { ACTIVITY_PERIODS, LOGIN } from "../constants/Constant";
import { formatPrice } from "../utils/PriceFormatter";
import { initializeEncryption } from "../services/AesGcmEncryption";
import { getFromLocalStorage } from "../utils/localStorageUtils";
import {
  LOGIN_ID,
  MESSAGE_KEY,
  SESSION_ID,
  USER_NAME,
} from "../constants/LocalStorageKeyValuePairString";
import { ApiErrorCode, ApiType } from "../services/ApiTags";
import { generateRequestId } from "../utils/RequestIdGenerator";
import { downloadPdfViewerData } from "../services/ApiService";
import {
  ALERT,
  ERROR,
  ERROR_FOUND_DURING_API_CALL,
  ERROR_WHILE_FETCHING_DATA,
  NO_INTERNET_CONNECTION_FOUND,
  PROCESSING_PLEASE_WAIT,
  } from "../constants/Strings";
import DebugLog from "../utils/DebugLog";
import { showErrorAlertDialog } from "../config/AppConfig";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import { useAtom } from "jotai";
import UseOnlineStatus from "../utils/UseOnlineStatus";
import PdfViewerDialog from "../scenes/exclusion/PdfViewerDialog";
import CustomProgressDialog from "./CustomProgressDialog";
import ConnectionStatus from "../utils/ConnectionStatus";
import ShowErrorAlertDialog from "./ErrorAlertDialog";

const UserActivityInfo = ({
  sectionHeading,
  sectionIcon,
  type,
  data,
  ondateRangeChange: onDateRangeChange,
  totalNoOfPages,
  onPageChange,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const { enqueueSnackbar } = useSnackbar();
  const [title, setTitle] = useState(ALERT);
  const [content, setContent] = useState("");
  const [, setError] = useState("");
  const [getDialogStatus, setErrorDialog] = useAtom(showErrorAlertDialog);

  const [getProgressbarText, setProgressbarText] = useState("");

  const [open, setOpen] = useState(false);
  const [commentData, setComment] = useState("");
  const [pdfData, setPdfData] = useState(null);
  const [imageUrl, setImageUrl] = useState(null);

  

  const isNetworkConnectionAvailable = UseOnlineStatus();
  const [earmarkActivityDetails, setearmarkActivityDetails] = useState([]);
  const [dateRange, setDateRange] = useState(ACTIVITY_PERIODS.THREE_MONTHS);

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  // const itemsPerPage = pageSize;

  // const indexOfLastItem = currentPage * itemsPerPage;
  // const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  // const currentItems = earmarkActivityDetails.slice(indexOfFirstItem, indexOfLastItem);
  // const pageCount = Math.ceil(earmarkActivityDetails.length / itemsPerPage)

  const pageCount = totalNoOfPages ? totalNoOfPages : 1;
  let blob;
  let filename;
  let url;
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleDateRangeChange = (event) => {
    setDateRange(event.target.value);
    onDateRangeChange(event.target.value);
  };

  useEffect(() => {
    if (data) {
      setearmarkActivityDetails(data);
    }
  }, [data]);

  // useEffect(() => {
  //     onPageChange(currentPage-1); // Call the handler function when the page changes
  // }, [currentPage, onPageChange]);

  const handlePageChange = (value) => {
    setCurrentPage(value);
    onPageChange(value - 1); // Index starts from 0 for data array
  };

  const getInitials = (name) => {
    // check if name is null or empty
    if (!name) return "";

    const words = name.split(" ");
    const initials = words
      .slice(0, 2)
      .map((word) => word[0])
      .join("")
      .toUpperCase();
    return initials;
  };

  // Function to get the initials of the user name
  function renderInitials(type, row) {
    switch (type) {
      case "EarmarkModule":
        return getInitials(row.modifiedBy);

      case "Payouts":
        return getInitials(row.nameOfUser);

      case "CashOutLimits":
        return getInitials(row.activityPerformedBy);

      default:
        return getInitials(row.createdBy);
    }
  }

  // Function to render the activity description based on the activity type
  function renderActivityDecription(type, row) {
    switch (type) {
      case "EarmarkModule":
        return (
          <Box>
            <span style={{ fontWeight: 600 }}>{row.modifiedBy}</span>
            <span>{` ${row.activity} for `}</span>
            <span style={{ fontWeight: 600 }}>{row.companyName}</span>
          </Box>
        );

      case "Payouts":
        return (
          <Box>
            <span style={{ fontWeight: 600 }}>{row.nameOfUser}</span>
            <span>{` ${row.activity} for `}</span>
            <span style={{ fontWeight: 600 }}>{row.batchName}</span>
          </Box>
        );

      case "CashOutLimits":
  if (row.activityPerformedOn?.toLowerCase().includes("global")) {
    return (
      <Box>
        <span style={{ fontWeight: 600 }}>{row.activityPerformedBy}</span>
        <span>{` ${row.activity} `}</span>
        <span style={{ fontWeight: 600 }}>{row.activityPerformedOn}</span>
      </Box>
    );
  } else {
    return (
      <Box>
        <span style={{ fontWeight: 600 }}>{row.activityPerformedBy}</span>
        <span>{` ${row.activity} for `}</span>
        <span style={{ fontWeight: 600 }}>{row.activityPerformedOn}</span>
      </Box>
    );
  }

      default: // Default case for types other than "EarmarkModule"
        return (
          <Box>
            <span style={{ fontWeight: 600 }}>{row.createdBy}</span>
            <span>{` updated account for `}</span>
            <span style={{ fontWeight: 600 }}>{row.companyName}</span>
          </Box>
        );
    }
  }

  // Function to render date based on the activity type
  function renderDate(type, row) {
    switch (type) {
      case "CreditDebitModule":
        return row.createdOn;

      case "Payouts":
        return row.dateOfActivity;

      case "CashOutLimits":
        return row.activityDate;

      default:
        return row.date;
    }
  }

  const openAttachment = (referenceId, attachmentType) => {
    let requestData ;
    try {
      if (isNetworkConnectionAvailable) {
        setProgressbarText(PROCESSING_PLEASE_WAIT);
        setLoading(true); // Hide the progress dialog

       
     
        if(attachmentType!==null && attachmentType!==undefined && attachmentType!==""){
          requestData = {
            attachmentType:attachmentType,
            referenceId: referenceId,
          };
        }else{
          requestData = {
            attachmentType: "FREEZE_ACCOUNTS",
            referenceId: referenceId,
          };
        }

        

        initializeEncryption(
          requestData,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.EXCLUSION_FILE_READ
        ).then((encryptedContentData) => {
          const addExclusionRequestData = {
            requestId: generateRequestId(),
            loginId: getFromLocalStorage(LOGIN_ID),
            sessionId: getFromLocalStorage(SESSION_ID),
            contentData: encryptedContentData,
            loginUserName: getFromLocalStorage(USER_NAME),
          };

          downloadPdfViewerData(addExclusionRequestData)
            .then((response) => {
              // Determine the content type from the headers
              const contentType = response.headers["content-type"];
              const mimeType = contentType.split(";")[0];
              const type = contentType.split("/")[1];

              // Handle different content types
              if (mimeType.includes("application/json")) {
                const arrayBuffer = response.data;

                // Function to convert ArrayBuffer to JSON
                const arrayBufferToJson = (buffer) => {
                  const decoder = new TextDecoder("utf-8");
                  const jsonString = decoder.decode(buffer);
                  return JSON.parse(jsonString);
                };

                // Convert the ArrayBuffer to JSON and set it in state
                const jsonObject = arrayBufferToJson(arrayBuffer);

                if (jsonObject !== null && jsonObject.responseCode === "-1") {
                  if (
                    jsonObject.displayErrorMessage !== null &&
                    jsonObject.displayErrorMessage !== ""
                  ) {
                    showErrorAlert(ERROR, jsonObject.displayErrorMessage);
                  } else {
                    showErrorAlert(ERROR, jsonObject.errorDescription);
                  }
                }
              } else {
                let fileBlob;
                switch (mimeType) {
                  case "image/png":
                    blob = new Blob([response.data], { type: "image/png" });
                    filename = referenceId + ".png";

                    url = URL.createObjectURL(blob);
                    setPdfData(null)
                    setImageUrl(url);
                    setOpen(true);

                    // fileBlob = new Blob([blob], { type: "image/png" });
                    // FileSaver.saveAs(fileBlob, filename);
                    break;

                  case "image/jpeg":
                    blob = new Blob([response.data], { type: "image/jpeg" });
                    filename = referenceId + ".jpeg";

                    url = URL.createObjectURL(blob);
                    setPdfData(null)
                    setImageUrl(url);
                    setOpen(true);

                    // fileBlob = new Blob([blob], { type: "image/jpeg" });
                    // FileSaver.saveAs(fileBlob, filename);
                    break;

                  case "image/jpg":
                    blob = new Blob([response.data], { type: "image/jpg" });
                    filename = referenceId + ".jpg";
                    url = URL.createObjectURL(blob);
                    setPdfData(null)
                    setImageUrl(url);
                    setOpen(true);
                    // fileBlob = new Blob([blob], { type: "image/jpg" });
                    // FileSaver.saveAs(fileBlob, filename);
                    break;

                  case "application/pdf":
                    blob = new Blob([response.data], {
                      type: "application/pdf",
                    });
                    filename = referenceId + ".pdf";
                    url = URL.createObjectURL(blob);
                    setImageUrl(null);
                    setPdfData(url);
                    setOpen(true);
                    break;

                  default:
                   
                     break;
                }

                if(mimeType!=="application/pdf" && mimeType!=="image/jpg" && mimeType!=="image/jpeg" && mimeType!=="image/png"){
                  showErrorAlert(ALERT,"File type is not supported!")
                }
              }
              setLoading(false);
             
            })
            .catch((error) => {
              setLoading(false);
              if (
                error !== null &&
                error !== undefined &&
                error.data !== null &&
                error.data !== undefined &&
                error.data.errorCode != null &&
                error.data.errorCode !== undefined &&
                error.data.errorCode === ApiErrorCode.SESSION_EXPIRED
              ) {
                navigate(LOGIN);
              } else if (
                error.data.errorCode === ApiErrorCode.SESSION_ID_NOT_FOUND
              ) {
                try {
                  navigate("/");
                } catch (error) {
                  DebugLog("error " + error);
                }
              } else {
                const message =
                  error.data != null
                    ? error.data.displayErrorMessage
                    : "Unknown";

                if (message)
                  showErrorAlert(
                    error.message,
                    ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
                  );
              }
            });
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      const message = error.response != null ? error.response : error.message;
      showErrorAlert(
        error.message,
        ERROR_FOUND_DURING_API_CALL + JSON.stringify(message)
      );
    }
  };

  const downloadPreviedFile = () => {};
  function showErrorAlert(title, content) {
    try {
      setError();
      setLoading(false);

      setTitle(title);
      setContent(content);
      setErrorDialog(true);
    } catch (error) {
      DebugLog(error);
    }
  }

  async function downloadViewablePdf(referenceId, attachmentType) {}

  return (
    <Box style={{ width: "100%" }}>
      <ShowErrorAlertDialog
        status={getDialogStatus}
        title={title}
        content={content}
      />
      <ConnectionStatus />
      {isNetworkConnectionAvailable ? (
        <CustomProgressDialog open={loading} text={getProgressbarText} />
      ) : (
        ""
      )}
      <PdfViewerDialog
        open={open}
        handleClose={handleClose}
        downloadPdf={downloadPreviedFile}
        pdfUrl={pdfData}
        imageUrl={imageUrl}
        comment={commentData}
      ></PdfViewerDialog>
      <Box sx={{ width: "100%" }}>
        {earmarkActivityDetails.length > 0 ? (
          <Grid
            container
            direction={"column"}
            mt={3}
            p={3}
            xs={12}
            mb={20}
            sx={{
              background: colors.grey[900],
              borderRadius: "12px",
            }}
          >
            <Grid container fontSize={20} fontWeight={700}>
              {/* Activity Header */}
              <Grid item xs={6}>
                Activity
              </Grid>

              {/* Time Period Dropdown */}
              <Grid item xs={6}>
                <Box display="flex" justifyContent="flex-end">
                  <Select
                    value={dateRange}
                    onChange={handleDateRangeChange}
                    displayEmpty
                    inputProps={{
                      "aria-label": "Select a time period",
                    }}
                    sx={{
                      height: "30px",
                      "& .MuiSelect-select": {
                        height: "30px",
                        display: "flex",
                        alignItems: "center",
                      },
                    }}
                    // IconComponent={"../../assets/common/Arrow-down.svg"}
                  >
                    {/* Create a menu item for each activity period defined in constants */}
                    {Object.values(ACTIVITY_PERIODS).map((period) => (
                      <MenuItem key={period} value={period}>
                        {period}
                      </MenuItem>
                    ))}
                  </Select>
                </Box>
              </Grid>
            </Grid>

            {earmarkActivityDetails.map((row) => (
              // Activity Row //
              <Grid item key={row.id} xs={12}>
                <Grid
                  container
                  direction={"row"}
                  mt={2}
                  spacing={2}
                  alignItems={"center"}
                >
                  {/* Avatar */}
                  <Grid item xl={0.5} lg={0.65} md={1} sm={1.5}>
                    <Avatar
                      sx={{
                        bgcolor: colors.grey[900],
                        color: colors.grey[100],
                        border: "1px solid #888888",
                      }}
                    >
                      {renderInitials(type, row)}
                    </Avatar>
                  </Grid>

                  {/* Content */}
                  <Grid item xl={9.5} lg={9.35} md={9} sm={8.5}>
                    <Typography>
                      {renderActivityDecription(type, row)}
                    </Typography>

                    {row.reason && (
                      <Grid item sx={{ overflowY: "auto" }}>
                        <Typography>
                          <span style={{ fontWeight: 600 }}>Reason: </span>
                          {row.reason}
                        </Typography>
                      </Grid>
                    )}

                    {row.action && (
                      <Grid item sx={{ overflowY: "auto" }}>
                        <Typography>
                          <span style={{ fontWeight: 600 }}>Action: </span>
                          {row.action}
                        </Typography>
                      </Grid>
                    )}

                    {row.attachmentReferenceId !== undefined &&
                      row.attachmentReferenceId !== null && (
                        <Grid item sx={{ overflowY: "auto" }}>
                          <Typography>
                            <Box
                              onClick={() =>
                                openAttachment(
                                  row.attachmentReferenceId,
                                  ""
                                )
                              }
                            >
                              <span
                                style={{
                                  fontWeight: 600,
                                  color: colors.redAccent[200],
                                }}
                              >
                                Attachment (Proof){" "}
                              </span>
                            </Box>
                          </Typography>
                        </Grid>
                      )}

                    {row.attachments !== undefined &&
                      row.attachments !== null &&
                      row.attachments.length > 0 &&
                      row.attachments[0].attachmentId !== null &&
                      row.attachments[0].attachmentId !== undefined 
                      && row.attachments[0].attachmentId !== "" && (
                        <Grid item sx={{ overflowY: "auto" }}>
                          <Typography>
                            <Box
                              onClick={() =>
                                openAttachment(
                                  row.attachments[0].attachmentId,
                                  row.attachments[0].attachmentType
                                )
                              }
                            >
                              <span
                                style={{
                                  fontWeight: 600,
                                  color: colors.redAccent[200],
                                }}
                              >
                                Attachment (Proof){" "}
                              </span>
                            </Box>
                          </Typography>
                        </Grid>
                      )}

                    {row.comment && (
                      <Grid item sx={{ overflowY: "auto" }}>
                        <Typography>
                          <span style={{ fontWeight: 600 }}>Comment: </span>
                          {row.comment}
                        </Typography>
                      </Grid>
                    )}

                    {row.dailyTransactionAmount &&
                      row.dailyTransactionCount && (
                        <Grid item sx={{ overflowY: "auto" }}>
                          <Typography>
                            <span>
                              Daily:&nbsp;&nbsp;&nbsp;
                              {formatPrice(row.dailyTransactionAmount)} /{" "}
                              {row.dailyTransactionCount}X
                            </span>
                          </Typography>
                        </Grid>
                      )}

                    {row.weeklyTransactionAmount &&
                      row.weeklyTransactionCount && (
                        <Grid item sx={{ overflowY: "auto" }}>
                          <Typography>
                            <span>
                              Weekly:&nbsp;&nbsp;&nbsp;
                              {formatPrice(row.weeklyTransactionAmount)} /{" "}
                              {row.weeklyTransactionCount}X
                            </span>
                          </Typography>
                        </Grid>
                      )}

                    {row.monthlyTransactionAmount &&
                      row.monthlyTransactionCount && (
                        <Grid item sx={{ overflowY: "auto" }}>
                          <Typography>
                            <span>
                              Monthly:&nbsp;&nbsp;&nbsp;
                              {formatPrice(row.monthlyTransactionAmount)} /{" "}
                              {row.monthlyTransactionCount}X
                            </span>
                          </Typography>
                        </Grid>
                      )}
                  </Grid>

                  {/* Date Time */}
                  <Grid
                    item
                    xl={2}
                    lg={2}
                    md={2}
                    sm={2}
                    sx={
                      {
                        // position: 'relative',
                        // right: '-10%',
                        // color: colors.grey[300],
                      }
                    }
                  >
                    {renderDate(type, row)}
                  </Grid>
                </Grid>
              </Grid>
              // Activity Row //
            ))}

            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              sx={{ marginTop: 3 }}
            >
              <Pagination
                count={pageCount}
                page={currentPage}
                onChange={(event, value) => handlePageChange(value)}
              />
            </Box>

            <Typography sx={{ marginTop: 2 }}>
              <span>Jump to page: </span>
              <select
                value={currentPage}
                onChange={(event) =>
                  handlePageChange(Number(event.target.value))
                }
                sx={{ marginRight: 2 }}
              >
                {[...Array(pageCount)].map((_, index) => (
                  <option key={index} value={index + 1}>
                    {index + 1}
                  </option>
                ))}
              </select>
            </Typography>
          </Grid>
        ) : (
          ""
        )}
      </Box>
    </Box>
  );
};

export default UserActivityInfo;
